
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class Row extends Vue {
  @Prop({required: true})
  item: { diametro: number, specieArboree: { specie: string, areaBasimetrica: number }[], totale: number };
}